import React from "react";
import { Avatar, Box, Button, Card, Chip, Stack, Typography } from "@mui/material";

function getSprintChip(thread) {
  if (thread?.activeSprint?.endsToday) return "Ends today";
  if (thread?.activeSprint?.quietToday) return "Quiet today";
  return "Active Accountability";
}

export default function ActiveSprintThreadCard({ thread, onOpen, onOpenPerson }) {
  if (!thread) return null;
  const openProfile = () => onOpenPerson?.(thread);

  return (
    <Card
      variant="outlined"
      sx={{
        p: 1.8,
        borderRadius: "8px",
        borderColor: "rgba(220, 230, 240, 0.96)",
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.05)",
      }}
    >
      <Typography variant="overline" sx={{ color: "#70839a", fontWeight: 800, letterSpacing: 0 }}>
        You're working with
      </Typography>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mt: 1.1 }}>
        <Box
          role="button"
          tabIndex={0}
          onClick={openProfile}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              openProfile();
            }
          }}
          sx={{
            display: "contents",
            cursor: "pointer",
            "&:focus-visible": { outline: "2px solid rgba(23, 52, 93, 0.24)", outlineOffset: 4 },
          }}
        >
          <Avatar src={thread?.partner?.avatar || ""} sx={{ width: 46, height: 46 }}>
            {(thread?.partner?.username || "T").slice(0, 1).toUpperCase()}
          </Avatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontWeight: 800, color: "#14213d", "&:hover": { color: "#17345d" } }}>
              {thread?.partner?.username || "Active Accountability"}
            </Typography>
          </Box>
        </Box>
        <Button variant="outlined" onClick={() => onOpen(thread)} sx={{ borderRadius: "8px", textTransform: "none" }}>
          Open chat
        </Button>
      </Stack>
      <Stack direction="row" spacing={1} sx={{ mt: 1.4 }}>
        <Chip
          label={getSprintChip(thread)}
          size="small"
          sx={{ borderRadius: "999px", backgroundColor: "#eef4fb", color: "#17345d", fontWeight: 800 }}
        />
        {thread?.activeSprint?.focusTitle ? (
          <Typography variant="caption" sx={{ color: "#70839a", fontWeight: 700, alignSelf: "center" }}>
            {thread.activeSprint.focusTitle}
          </Typography>
        ) : null}
      </Stack>
    </Card>
  );
}
